import styled from 'styled-components'

export const MenuContainer = styled.div`
  display: flex;
  width: 30px;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

export const Icon = styled.img`
  width: 30px;
  height: 30px;
`
export const MenuLine = styled.div`
  width: 30px;
  margin: 2px 0 2px 0;
  border: 2px solid white;
  border-radius: 2px;
`



// WEBPACK FOOTER //
// ./src/Components/ParentPlatform/Navbar/Styles.jsx